import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { compose } from 'recompose';
import { withStyleSheet } from 'hoc/styles';
import { Div } from 'components/Div';
import { Text } from 'components/Text';
import { PERMISSIONS } from 'consts';
import { WithPermission } from 'components/WithPermission';
import { styleSheet } from './stylesheet';

class AieraChat extends PureComponent {
    static propTypes = {
        passedStyles: PropTypes.objectOf(PropTypes.any),
        styles: PropTypes.objectOf(PropTypes.any).isRequired
    };

    static defaultProps = {
        passedStyles: {}
    };

    render() {
        const { passedStyles, styles } = this.props;
        return (
            <WithPermission permissions={PERMISSIONS.featureAieraChat}>
                {({ isLoading, restricted }) =>
                    isLoading || restricted ? (
                        <Div styles={styles.loading}>
                            <Text size={3}>
                                {isLoading ? 'AieraChat Loading...' : 'Please contact support for AieraChat Access'}
                            </Text>
                        </Div>
                    ) : (
                        <Div styles={{ ...styles.container, ...passedStyles }}>
                            <iframe width="100%" title="AieraChat" height="100" id="aiera-chat-frame" />
                        </Div>
                    )
                }
            </WithPermission>
        );
    }
}

export const AieraChatUI = compose(withStyleSheet(styleSheet))(AieraChat);
